import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import depositIcon from '@/assets/images/icons/myacc_icon_deposit.png'
import withdrawalIcon from '@/assets/images/icons/myacc_icon_withdrawal.png'
import transferIcon from '@/assets/images/icons/myacc_icon_transfer.png'
import { openCashDialog } from '@/actions/app';
import { getSafe } from '@/helpers/global';


class FundManagement extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { language } = this.props

    return (
      <div className={classnames("section", 'fund-management')}>
        <div className="section-title">
          {getSafe(() => language.fund_management_title)}
        </div>
        <div className="fund-management-content">
          <div className="account-action-box" onClick={() => openCashDialog(0)}>
            <div className="account-action-icon">
              <img className="auto-img" src={depositIcon} alt="Cash Deposit icon" />
            </div>
            <div>{getSafe(() => language.fund_management_cash_deposit)}</div>
          </div>
          <div className="account-action-box" onClick={() => openCashDialog(1)}>
            <div className="account-action-icon">
              <img className="auto-img" src={withdrawalIcon} alt="Cash Deposit icon" />
            </div>
            <div>{getSafe(() => language.fund_management_cash_withdrawal)}</div>
          </div>
          {/* <div className="account-action-box" onClick={() => openCashDialog(2)}>
            <div className="account-action-icon">
              <img className="auto-img" src={transferIcon} alt="Cash Deposit icon" />
            </div>
            <div>{getSafe(() => language.fund_management_cash_transfer)}</div>
          </div> */}
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme
  })
)(FundManagement)